/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{visibility:hidden!important;pointer-events:none;width:0;height:0;z-index:-1}button[_ngcontent-%COMP%]{pointer-events:auto!important;visibility:visible!important;z-index:98}button[disabled][_ngcontent-%COMP%]{pointer-events:none;visibility:visible!important}div[_ngcontent-%COMP%], span[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
